// extracted by mini-css-extract-plugin
export default {"accountContainer":"Account_accountContainer__rpFb3","myrow":"Account_myrow__nF6un","valuerow":"Account_valuerow__gzOXb","label":"Account_label__i46YJ","value":"Account_value__2Ts6o"};